<template>
  <div class="application d-flex align-center justify-center">
    <div class="content d-flex f-column align-center">
      <h3>区块链在溯源中的运用</h3>
      <p>
        溯源通过结合区块链技术手段和区块链治理思想的方式，实现了区块链在溯源中的重大价值
      </p>
      <div class="d-flex">
        <div class="item">
          <div class="title">技术方面</div>
          <div class="desc">
            通过区块链为溯源平台提供了很好的技术基础，保障了数据的真实可追溯
          </div>
          <div class="iconfont icon-jishufuwu"></div>
        </div>
        <div class="item">
          <div class="title">应用方面</div>
          <div class="desc">
            智能合约在应用层面会成为帮助解决溯源的关键问题，提供更加有价值的信息和服务
          </div>
          <div class="iconfont icon-yonghufenzuyingyong"></div>
        </div>
        <div class="item">
          <div class="title">生态层面</div>
          <div class="desc">
            区块链技术可打造多中心、按劳分配、价值共享、利益公平分配的自治价值溯源体系
          </div>
          <div class="iconfont icon-ziyuan"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.application {
  background-color: #f9fafe;
  padding-bottom: 1.25rem;
  .content {
    h3 {
      padding: 1.25rem 0 0.375rem;
      font-size: 0.375rem;
    }
    p {
      font-size: 0.2rem;
      color: #666;
      margin-bottom: 1rem;
    }
    .item {
      float: left;
      position: relative;
      width: 4.8125rem;
      height: 3.5625rem;
      box-shadow: 0.025rem 0.025rem 0.05rem 0 rgba(153, 153, 153, 0.4);
      background-color: #ffffff;
      margin-right: 0.275rem;
      padding: 0.45rem 0.5rem;
      user-select: none;
      &:last-of-type {
        margin-right: 0;
      }
      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 0.075rem;
        background-color: transparent;
      }
      &::after {
        content: '';
        position: absolute;
        top: 0.4rem;
        right: 0.325rem;
        width: 2.3375rem;
        height: 1.675rem;
        background: url('../../../assets/images/one.png') no-repeat;
        background-size: 2.3375rem 1.675rem;
      }
      &:nth-of-type(1) {
        &::after {
          width: 2.0625rem;
          height: 1.675rem;
          background-size: 2.0625rem 1.675rem;
        }
      }
      &:nth-of-type(2) {
        &::after {
          background: url('../../../assets/images/two.png') no-repeat;
        }
      }
      &:nth-of-type(3) {
        &::after {
          background: url('../../../assets/images/three.png') no-repeat;
        }
      }
      .title {
        position: relative;
        line-height: 0.6rem;
        font-weight: bold;
        font-size: 0.3rem;
        color: #666;
        margin-bottom: 0.375rem;
        &::before {
          content: '';
          position: absolute;
          bottom: 0;
          width: 0.3125rem;
          height: 0.0375rem;
          background-color: #666;
        }
      }
      .desc {
        line-height: 0.3rem;
        font-size: 0.175rem;
        color: #999;
      }
      .iconfont {
        margin-top: 0.375rem;
        font-size: 0.5rem;
        color: #999;
      }
      &:hover {
        &::before {
          background-color: #2373f0;
        }
        .title {
          color: #2373f0;
          &::before {
            background-color: #2373f0;
          }
        }
        .iconfont {
          color: #2373f0;
        }
      }
    }
  }
}
</style>
